<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="3" class="my-1">

            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>

          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getSlineRequestList('Normal', '0', '0', '1', '1')"></date-range-picker>
          </b-col>
          <b-col md="3">
            <label>Common Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter" id="commonFilter"
              name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
              @input="getSlineRequestList('Normal', '0', '0', '1', '1')"></b-form-input>
          </b-col>

          <b-col md="2">
            <b-button class="pull-right ml-1 mt-5" :variant="Filter.TransactionNoFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.TransactionNoFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-5" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

          </b-col>

          <b-col cols="9">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="3">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>

          <b-col cols="12">
            <div v-if="visible">
              <b-card>
                <b-collapse v-model="visible" id="collapse-2">
                  <b-row>

                    <b-col md="3">
                      <label>Date</label>
                      <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        :disabled="Filter.DFlag ? true : false"
                        @update="getSlineRequestList('Normal', '0', '0', '1', '1')"></date-range-picker>
                    </b-col>
                    <b-col md="3">
                      <label>Transaction NO Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Transaction NO Filter"
                        id="TransactionNoFilter" name="TransactionNoFilter" autocomplete="off"
                        v-model="Filter.TransactionNoFilter"
                        @input="getSlineRequestList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>


                    <b-col md="3">
                      <label>Common Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                        id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                        @input="getSlineRequestList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>

                    <b-col md="3">
                      <label>
                        <b> Created User </b>
                      </label>
                      <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                        @input="getSlineRequestList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                        option-value="userId" option-text="employeeName"
                        placeholder="Select Created User"></model-list-select>
                    </b-col>

                    <b-col md="12" class="mt-2">
                      <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                        variant="outline-danger">Reset</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
          </b-col>


          <b-col cols="12" class="table-responsive tableMain ">

            <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentFields"
              primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
              class="position-relative">
              <template slot="checkbox" slot-scope="row0">
                <div class="d-flex align-items-center gap-2">
                  <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                    variant="outline-info">
                    <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                    {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                    Details
                  </b-button>

                </div>
              </template>
              <template slot="SN" slot-scope="row0">
                <span>
                  {{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}
                </span>
              </template>

              <template slot="msr_transaction_no" slot-scope="row1">
                <strong>Transaction No:</strong>{{ row1.item.msr_transaction_no }}<br />
                <strong>Created By:</strong> {{ row1.item.createdBy }}<br />
                <strong>Created At:</strong> {{ row1.item.msr_created_at }}<br />
                <strong>Updated By:</strong> {{ row1.item.updatedBy }}<br />
                <strong>Updated At:</strong> {{ row1.item.msr_updated_at }}<br />
              </template>

              <template slot="createdBy" slot-scope="row1">
                <div v-for="(item, index) in row1.item.m_sline_shipping_request" :key="index"
                  class="mb-4 p-1 border rounded">
                  <b-row class="mb-2">
                    <b-col md="12" class="mb-2"><strong>Shipping Line:</strong> {{
                      item.shippinglinemaster_relation.shippingLine
                    }}</b-col>
                    <b-col md="12">
                      <div class="mt-3 table-responsive-child">
                        <table class="table table-bordered table-sm table-hover">
                          <thead class="thead-light">
                            <tr>
                              <th :style="'width:5%'">SN</th>
                              <th :style="'width:5%'">Trax No</th>
                              <th :style="'width:5%'">Pay Type</th>
                              <th :style="'width:5%'">Job No</th>
                              <th :style="'width:5%'">Job Date</th>
                              <th :style="'width:8%'">Inv No</th>
                              <th :style="'width:5%'">Inv Created</th>
                              <th :style="'width:5%'">Inv Amt</th>
                              <th :style="'width:5%'">Inv Currency</th>
                              <th :style="'width:20%'">Pay To</th>
                              <th :style="'width:8%'">Account No</th>
                              <th :style="'width:5%'">IFSC Code</th>
                              <th :style="'width:5%'">Branch</th>
                              <th :style="'width:10%'">To Be Paid</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item1, index1) in item.sline_payment_request_final" :key="index1">
                              <td>{{ parseInt(index1) + 1 }}</td>
                              <td>{{ item1.sprf_transaction_no }}</td>
                              <td>{{ item1.sprf_payment_type }}</td>
                              <td>{{ item1.ffsline_main_sales_execution_relation.mainSalesSeries }}</td>
                              <td>{{ formatDate(item1.ffsline_main_sales_execution_relation.loginTime) }}</td>
                              <td>{{
                                item1.sprf_payment_type == 'FF' ?
                                  item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvNo :
                                  item1.sprf_payment_type
                                    ==
                                    'CC' ? item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvNo :
                                    item1.sprf_payment_type ==
                                      'IMP' ? item1.import_sline_invoices_amount_relation.SlineInvNo : ''
                              }}</td>
                              <td>{{
                                item1.sprf_payment_type == 'FF' ?
                                  formatDate(item1.ffsline_ffsea_export_sline_invoices_amount_relation.creationTime) :
                                  item1.sprf_payment_type == 'CC' ?
                                    formatDate(item1.ccsea_export_sline_invoices_amount_relation.creationTime) :
                                    item1.sprf_payment_type
                                      == 'IMP' ? formatDate(item1.import_sline_invoices_amount_relation.creationTime) : ''
                              }}</td>
                              <td>{{
                                item1.sprf_payment_type == 'FF' ?
                                  formatAmount(item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvAmount)
                                  :
                                  item1.sprf_payment_type == 'CC' ?
                                    formatAmount(item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvAmount) :
                                    item1.sprf_payment_type == 'IMP' ?
                                      formatAmount(item1.import_sline_invoices_amount_relation.SlineInvAmount) : ''
                              }}</td>
                              <td>{{
                                item1.sprf_payment_type == 'FF' ?
                                  item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvCurrency :
                                  item1.sprf_payment_type
                                    == 'CC' ? item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvCurrency :
                                    item1.sprf_payment_type == 'IMP' ?
                                      item1.import_sline_invoices_amount_relation.SlineInvCurrency : ''
                              }}</td>
                              <td>{{ item1.sprf_pay_to }}</td>
                              <td>{{ item1.sprf_pay_to }}</td>
                              <td>{{ item1.sprf_ifsc_code }}</td>
                              <td>{{ item1.sprf_branch_name }}</td>
                              <td>{{ item1.sprf_to_be_paid_amt }}</td>

                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-col>
                  </b-row>

                </div>
              </template>

              <template slot="msr_id" slot-scope="row1">
                <b-button variant="primary" @click="viewRequest(row1.item)" class="pull-right ml-1 mt-5 btn-sm"
                  style="font-size: 0.675rem">
                  View Request
                </b-button>
                <b-button variant="warning" @click="downloadRequest(row1.item)" class="pull-right ml-1 mt-5 btn-sm"
                  style="font-size: 0.675rem">
                  Download Request
                </b-button>
              </template>
            </b-table>
          </b-col>
          <b-col md="12">
            <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-modal id="confirm-bulk-payment" ref="confirm-bulk-payment" :title="`Confirm Final to Release`" class="w-90"
      size="xl" no-close-on-esc no-close-on-backdrop hide-footer>

      <b-card v-if="RequestData && RequestData.msr_transaction_no" class="shadow-sm rounded">
        <b-card-body>

          <!-- Header -->
          <b-row class="mb-3">
            <b-col md="4">
              <strong>Transaction No:</strong> {{ RequestData.msr_transaction_no }}
            </b-col>
            <b-col md="4">
              <strong>Transaction Date:</strong> {{ formatDate(RequestData.msr_created_at) }}
            </b-col>
            <b-col md="4">
              <strong>Created By:</strong> {{ RequestData.createdBy }}
            </b-col>
          </b-row>

          <!-- Shipping Line Table -->
          <div v-for="(item, index) in RequestData.m_sline_shipping_request" :key="index"
            class="mb-4 p-3 border rounded">
            <b-row class="mb-2">
              <b-col md="12"><strong>Shipping Line:</strong> {{ item.shippinglinemaster_relation.shippingLine }}</b-col>

            </b-row>

            <!-- Inner Invoices Table -->
            <div class="mt-3 table-responsive-child">
              <table class="table table-bordered table-sm table-hover">
                <thead class="thead-light">
                  <tr>
                    <th :style="'width:5%'">SN</th>
                    <th :style="'width:5%'">Trax No</th>
                    <th :style="'width:5%'">Pay Type</th>
                    <th :style="'width:5%'">Job No</th>
                    <th :style="'width:5%'">Job Date</th>
                    <th :style="'width:8%'">Inv No</th>
                    <th :style="'width:5%'">Inv Created</th>
                    <th :style="'width:5%'">Inv Amt</th>
                    <th :style="'width:5%'">Inv Currency</th>
                    <th :style="'width:20%'">Pay To</th>
                    <th :style="'width:8%'">Account No</th>
                    <th :style="'width:5%'">IFSC Code</th>
                    <th :style="'width:5%'">Branch</th>
                    <th :style="'width:10%'">To Be Paid</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1, index1) in item.sline_payment_request_final" :key="index1">
                    <td>{{ parseInt(index1) + 1 }}</td>
                    <td>{{ item1.sprf_transaction_no }}</td>
                    <td>{{ item1.sprf_payment_type }}</td>
                    <td>{{ item1.ffsline_main_sales_execution_relation.mainSalesSeries }}</td>
                    <td>{{ formatDate(item1.ffsline_main_sales_execution_relation.loginTime) }}</td>
                    <td>{{
                      item1.sprf_payment_type == 'FF' ?
                        item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvNo :
                        item1.sprf_payment_type
                          ==
                          'CC' ? item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvNo :
                          item1.sprf_payment_type ==
                            'IMP' ? item1.import_sline_invoices_amount_relation.SlineInvNo : ''
                    }}</td>
                    <td>{{
                      item1.sprf_payment_type == 'FF' ?
                        formatDate(item1.ffsline_ffsea_export_sline_invoices_amount_relation.creationTime) :
                        item1.sprf_payment_type == 'CC' ?
                          formatDate(item1.ccsea_export_sline_invoices_amount_relation.creationTime) :
                          item1.sprf_payment_type
                            == 'IMP' ? formatDate(item1.import_sline_invoices_amount_relation.creationTime) : ''
                    }}</td>
                    <td>{{
                      item1.sprf_payment_type == 'FF' ?
                        formatAmount(item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvAmount)
                        :
                        item1.sprf_payment_type == 'CC' ?
                          formatAmount(item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvAmount) :
                          item1.sprf_payment_type == 'IMP' ?
                            formatAmount(item1.import_sline_invoices_amount_relation.SlineInvAmount) : ''
                    }}</td>
                    <td>{{
                      item1.sprf_payment_type == 'FF' ?
                        item1.ffsline_ffsea_export_sline_invoices_amount_relation.ffSlineInvCurrency :
                        item1.sprf_payment_type
                          == 'CC' ? item1.ccsea_export_sline_invoices_amount_relation.ccSlineInvCurrency :
                          item1.sprf_payment_type == 'IMP' ?
                            item1.import_sline_invoices_amount_relation.SlineInvCurrency : ''
                    }}</td>
                    <td>{{ item1.sprf_pay_to }}</td>
                    <td>{{ item1.sprf_pay_to }}</td>
                    <td>{{ item1.sprf_ifsc_code }}</td>
                    <td>{{ item1.sprf_branch_name }}</td>
                    <td>{{ item1.sprf_to_be_paid_amt }}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Action Buttons -->
          <b-row>
            <b-col class="text-right">
              <b-button variant="outline-danger" size="sm" @click="resetModal">Cancel</b-button>
            </b-col>
          </b-row>

        </b-card-body>
      </b-card>


      <!-- You could also include item details here if needed -->
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),

      this.$store.dispatch(
        "commonDropdownMaster/setAllSlineAccDDList",
        JSON.stringify({
          itemCode: "AllSlineAccDDList",
        })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch(
        "commonDropdownMaster/setAllPendingSlineInvDDList",
        {
          itemCode: "LocationList",
          isSelectedColumn: '1',
          isAll: '1',
          page: 1,
          pageSize: 1,
          generateExcel: 0,
          search_txt: '',
          filter: '',
        }
      ),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getSlineRequestList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {

  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getPaymentList: [],
      totalData: 0,
      RequestData: null,

      validate: true,

      // Date format for datepickers

      dateFormat: { year: "numeric", month: "short", day: "numeric" },

      PaymentFields: [

        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "msr_transaction_no",
          mainkey: "msr_transaction_no",
          label: "Req. Tranasaction No.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "createdBy",
          mainkey: "createdBy",
          label: "Request Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "msr_id",
          mainkey: "msr_id",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {

        TransactionNoFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {


  },
  watch: {

  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    formatAmount(amount) {
      return parseFloat(amount || 0).toFixed(2);
    },

    downloadRequest(item) {
      console.log('item=>', item);
      this.generateExcel="1";
      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      this.isLoading = true;
      payload = {
        msr_id: item.msr_id,
        msr_transaction_no: item.msr_transaction_no,
        filter: this.Filter,
        generateExcel: "1",
      };
      // Set responseType to 'blob' if generating Excel
      const config =  { responseType: "blob" };
      NodeLockPannelService.downloadAllPaymentRequestList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              const now = new Date();
              const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}-${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;

              link.setAttribute("download", `get-Sales-Payment-Request-panel-report-${item.msr_transaction_no}-${formattedDateTime}.xlsx`); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              console.log("this.generateExcel", this.generateExcel);
              this.getSlineRequestList("Normal", "0", "0", "1", "1");
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    viewRequest(item) {
      this.RequestData = item;
      console.log('item=>', item)
      this.$refs["confirm-bulk-payment"].show();
    },
    resetModal() {
      this.RequestData = null;
      this.$refs["confirm-bulk-payment"].hide();
    },


    clearFilter() {
      this.Filter = {
        TransactionNoFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getSlineRequestList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate, // 11/02/2025
        endDate: endDate,     // 12/02/2025
      };
    },

    getSlineRequestList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllPaymentRequestList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-Request-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getSlineRequestList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalPaymentList;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.pagination.totalPaymentList;
                this.pagination.currentPage = data.pagination.currentPage;
                this.pagination.perPage = data.pagination.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getSlineRequestList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getSlineRequestList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlineRequestList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlineRequestList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>
<style>
.table-responsive-child {
  max-height: 300px;
  overflow-y: auto;
}

.w-90 .modal-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// slinePaymentRequestFinalList.vue?54b1e83c